import { relations, sql } from "drizzle-orm";
import { integer, jsonb, pgTable, text, timestamp, unique, uuid, } from "drizzle-orm/pg-core";
import { dossier, dossierDocument } from "./dossier.js";
import { agency, appUser } from "./main.js";
export const ConversationType = ["upload", "recording"];
export const ConversationStatus = [
    "pending",
    "ready_to_transcribe",
    "transcribing",
    "ready_to_summarize",
    "summarizing",
    "processed",
    "errored",
];
export const conversationTable = pgTable("conversation", {
    title: text("title"),
    generatedTitle: text("generated_title"),
    displayId: integer("display_id"),
    durationInSeconds: integer("duration_in_seconds"),
    summary: text("summary"),
    status: text("status")
        .notNull()
        .default("pending")
        .$type(),
    recordingId: uuid("recording_id").references(() => dossierDocument.id, {
        onUpdate: "cascade",
        onDelete: "set null",
    }),
    type: text("type").notNull().$type(),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
    createdBy: uuid("created_by").references(() => appUser.id, {
        onDelete: "set null",
    }),
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    agencyId: uuid("agency_id")
        .notNull()
        .references(() => agency.id, {
        onDelete: "cascade",
    }),
    dossierId: uuid("dossier_id").references(() => dossier.id, {
        onDelete: "set null",
    }),
    // TODO: remove in the future, when details table is verified to be working
    transcriptionResult: jsonb("transcription_result").$type(),
}, (t) => [unique().on(t.agencyId, t.displayId)]);
export const conversationDetail = pgTable("conversation_detail", {
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    conversationId: uuid("conversation_id")
        .notNull()
        .unique()
        .references(() => conversationTable.id, {
        onDelete: "cascade",
    }),
    agencyId: uuid("agency_id")
        .notNull()
        .references(() => agency.id, {
        onDelete: "cascade",
    }),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
    transcriptionResult: jsonb("transcription_result").$type(),
});
export const conversationDetailRelations = relations(conversationDetail, ({ one }) => ({
    conversation: one(conversationTable, {
        fields: [conversationDetail.conversationId],
        references: [conversationTable.id],
    }),
    agency: one(agency, {
        fields: [conversationDetail.agencyId],
        references: [agency.id],
    }),
}));
export const conversationRelations = relations(conversationTable, ({ one, many }) => ({
    agency: one(agency, {
        fields: [conversationTable.agencyId],
        references: [agency.id],
    }),
    creator: one(appUser, {
        fields: [conversationTable.createdBy],
        references: [appUser.id],
    }),
    recording: one(dossierDocument, {
        fields: [conversationTable.recordingId],
        references: [dossierDocument.id],
    }),
    dossier: one(dossier, {
        fields: [conversationTable.dossierId],
        references: [dossier.id],
    }),
    editHistory: many(summaryEditHistory),
    detail: one(conversationDetail, {
        fields: [conversationTable.id],
        references: [conversationDetail.conversationId],
    }),
}));
export const summaryEditHistory = pgTable("summary_edit_history", {
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    conversationId: uuid("conversation_id")
        .notNull()
        .references(() => conversationTable.id, {
        onDelete: "cascade",
    }),
    diff: text("diff").notNull(),
    editedBy: uuid("edited_by").references(() => appUser.id, {
        onDelete: "set null",
    }),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
});
export const summaryEditHistoryRelations = relations(summaryEditHistory, ({ one }) => ({
    conversation: one(conversationTable, {
        fields: [summaryEditHistory.conversationId],
        references: [conversationTable.id],
    }),
    editor: one(appUser, {
        fields: [summaryEditHistory.editedBy],
        references: [appUser.id],
    }),
}));
